<script lang="ts" setup>
    import userIcon from '~/assets/icons/circle-user-round-white.svg';

    const props = defineProps<{
        blok: HeroComponentStoryblok;
    }>();

    const { isLoggedIn, displayFirstName } = useLoginState();
    const isLoggedInClient = useClientGate(isLoggedIn);

    const loginModal = useLoginModal();
    const loginModalController = useModal();

    const loginButtonText = computed(() => $t('fachkreis.hero.loginCta'));

    const postLoginHeadline = computed(() =>
        $t('fachkreis.hero.postLoginHeadline', {
            user: displayFirstName.value
        })
    );
    const postLoginSubheadline = computed(() =>
        $t('fachkreis.hero.postLoginSubheadline', {
            user: displayFirstName.value
        })
    );
    const postLoginText = computed(() => $t('fachkreis.hero.postLoginText'));
</script>

<template>
    <div
        ref="hero"
        v-editable="blok"
        class="hero"
    >
        <div
            class="hero-container"
            :class="{ '--logged-in': isLoggedInClient }"
        >
            <div
                v-if="!isLoggedInClient"
                class="content-wrapper"
            >
                <div class="text-content">
                    <RichText :doc="props.blok.headline" />
                </div>

                <div class="advantages">
                    <Advantages
                        :title="loginModal?.headline"
                        :story-id="loginModal?.contentUuid"
                        :is-fachkreis-hero="true"
                    >
                        <template #cta>
                            <div class="button-wrapper">
                                <PrimaryButton
                                    :aria-label="loginButtonText"
                                    :button-text="loginButtonText"
                                    product-button
                                    size="small"
                                    @click="loginModalController.open"
                                >
                                    <template #customIcon>
                                        <img
                                            :src="userIcon"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                    </template>
                                </PrimaryButton>

                                <DocCheckLoginButton
                                    :text="loginButtonText"
                                    size="small"
                                />
                            </div>
                        </template>
                    </Advantages>
                </div>
            </div>

            <div v-else>
                <div class="text-content">
                    <h1 id="fachkreis-headline">
                        <span id="subheadline">{{ postLoginSubheadline }}</span>
                        <span id="headline">{{ postLoginHeadline }}</span>
                    </h1>

                    <h2>
                        {{ postLoginText }}
                    </h2>
                </div>
            </div>
        </div>

        <HeroScrollDown v-if="!isLoggedInClient" />

        <FachkreisHeroBackground />

        <SharedLoginModal :login-modal-controller="loginModalController" />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/fachkreis/fachkreis-hero.scss';
    @import '~/assets/scss/basics/loading-skeleton.scss';
</style>
